export const NoAuthorizationNeededMessage = () => (
    <span className="sds_prior_authorization_grid__none-needed">
        No additional authorization needed at the time of assignment for this referral.
    </span>
);
